import type { ThemePreset } from "../types";

export const sunset: ThemePreset = {
  id: "sunset",
  name: "Sonnenuntergang",
  nameKey: "admin.settings.appearance.themes.sunset.name",
  description: "Warme Orange- und Amber-Töne",
  descriptionKey: "admin.settings.appearance.themes.sunset.description",
  light: {
    background: "oklch(0.985 0.005 60)",
    foreground: "oklch(0.15 0.02 50)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 50)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 50)",
    primary: "oklch(0.65 0.18 55)",
    "primary-foreground": "oklch(0.15 0.02 50)",
    secondary: "oklch(0.95 0.02 55)",
    "secondary-foreground": "oklch(0.22 0.02 50)",
    muted: "oklch(0.95 0.015 55)",
    "muted-foreground": "oklch(0.50 0.02 50)",
    accent: "oklch(0.93 0.03 50)",
    "accent-foreground": "oklch(0.22 0.02 50)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.91 0.02 55)",
    input: "oklch(0.91 0.02 55)",
    ring: "oklch(0.65 0.18 55)",
    "sidebar-background": "oklch(0.98 0.008 55)",
    "sidebar-foreground": "oklch(0.30 0.02 50)",
    "sidebar-primary": "oklch(0.65 0.18 55)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 50)",
    "sidebar-accent": "oklch(0.93 0.025 50)",
    "sidebar-accent-foreground": "oklch(0.22 0.02 50)",
    "sidebar-border": "oklch(0.91 0.02 55)",
    "sidebar-ring": "oklch(0.65 0.18 55)",
  },
  dark: {
    background: "oklch(0.17 0.02 40)",
    foreground: "oklch(0.92 0.01 50)",
    card: "oklch(0.20 0.02 40)",
    "card-foreground": "oklch(0.92 0.01 50)",
    popover: "oklch(0.20 0.02 40)",
    "popover-foreground": "oklch(0.92 0.01 50)",
    primary: "oklch(0.72 0.16 55)",
    "primary-foreground": "oklch(0.15 0.02 50)",
    secondary: "oklch(0.25 0.02 45)",
    "secondary-foreground": "oklch(0.90 0.01 50)",
    muted: "oklch(0.25 0.02 45)",
    "muted-foreground": "oklch(0.65 0.02 50)",
    accent: "oklch(0.28 0.025 45)",
    "accent-foreground": "oklch(0.92 0.01 50)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.02 45)",
    input: "oklch(0.30 0.02 45)",
    ring: "oklch(0.72 0.16 55)",
    "sidebar-background": "oklch(0.14 0.02 40)",
    "sidebar-foreground": "oklch(0.82 0.015 50)",
    "sidebar-primary": "oklch(0.72 0.16 55)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 50)",
    "sidebar-accent": "oklch(0.22 0.02 45)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 50)",
    "sidebar-border": "oklch(0.28 0.02 45)",
    "sidebar-ring": "oklch(0.72 0.16 55)",
  },
};
